import { put } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* addLogSaga(action) {
  yield put(actions.addLogStart());
  try {
    const response = yield axios.post(
      '/logs',
      action.formData
    );
    yield put(
      actions.initLogs(action)
    );
    yield put(
      actions.addLogSuccess(response.data, action)
    );
  } catch (error) {
    // console.error('ERROR', error);
    yield put(actions.addLogFail(error));
  }
}

export function* initLogsSaga(action) {
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const divId = yield sessionStorage.getItem('divId');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const multi = yield sessionStorage.getItem('multi');


  if (sessionToken) {
    yield put(actions.initLogsStart());
    try {
      let response = {};
      response = yield axios.get(
        `/changeLogs?multi=${multi}`,

        {
          accountNumber: accountNumber,
          divId: divId,
          sessionToken: sessionToken,
          multi: multi
        }
      ).then(res => {
        let parsedData = res.data
        if (Array.isArray(parsedData)) {
          return parsedData
        }
        else {
          return []
        }
      })
      yield put(actions.setLogs(response));
    } catch (error) {
      yield put(actions.fetchLogsFailed());
    }
  } else {
    // console.log('NO TOKEN')
  }
}

export function* getLogLinkSaga(action) {
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    try {
      let response = {};
      response = yield axios.post(
        '/getLogLink',
        {
          bToken: token,
          sessionToken: sessionToken
        }
      ).then(res => {
        let parsedData = JSON.parse(res.data.message)

        return parsedData

      })
      yield put(actions.setLogLink(response.fileName));
    } catch (error) {
      yield put(actions.fetchLogLinkFailed());
    }
  } else {
    // console.log('NO TOKEN')
  }

}

export function* deleteLogSaga(action) {
  try {
    const response = yield axios.delete(
      '/logs',
      {
        params: {
          id: action.logId,
          identifier: 'id'
        }
      }
    );
    yield put(actions.initLogs(response.data));
  } catch (error) {
    yield put(actions.fetchLogsFailed());
  }
}

export function* editLogSaga(action) {
  yield put(actions.editLogStart());
  try {
    const response = yield axios.put(
      '/logs',
      action.payload
    );
    yield put(
      actions.editLogSuccess(response.data, action.payload)
    );
    if (action.payload.fromDetailsPage) {
      yield put(actions.getOneLog(action.payload.id));
    } else {
      yield put(actions.initLogs());
    }
  } catch (error) {
    // console.error('ERROR', error);
    yield put(actions.editLogFail(error));
  }
}
